var bseNseExpiryMapper = function (data) {
    var result = {
        nse: {},
        bse: {},
    };
    if (data) {
        result.nse = convertNseBseContent(data.nse);
        result.bse = convertNseBseContent(data.bse);
    }
    return result;
};
export default bseNseExpiryMapper;
var convertNseBseContent = function (data) {
    var _a, _b, _c;
    return {
        curSymList: (_a = data === null || data === void 0 ? void 0 : data.curSymList) === null || _a === void 0 ? void 0 : _a.map(function (list) {
            var _a;
            return {
                instrument: list === null || list === void 0 ? void 0 : list.ins,
                symbolList: (_a = list === null || list === void 0 ? void 0 : list.symLst) === null || _a === void 0 ? void 0 : _a.map(function (sym) {
                    return {
                        description: sym === null || sym === void 0 ? void 0 : sym.desc,
                        exchange: sym === null || sym === void 0 ? void 0 : sym.exc,
                        expiryListIdx: sym === null || sym === void 0 ? void 0 : sym.expLstIdx,
                        stockName: sym === null || sym === void 0 ? void 0 : sym.sname,
                    };
                }),
            };
        }),
        dervSymList: (_b = data === null || data === void 0 ? void 0 : data.dervSymList) === null || _b === void 0 ? void 0 : _b.map(function (list) {
            var _a;
            return {
                instrument: list === null || list === void 0 ? void 0 : list.ins,
                symbolList: (_a = list === null || list === void 0 ? void 0 : list.symLst) === null || _a === void 0 ? void 0 : _a.map(function (sym) {
                    return {
                        displayName: sym === null || sym === void 0 ? void 0 : sym.dpNm,
                        displayValue: sym === null || sym === void 0 ? void 0 : sym.dpVal,
                        exchange: sym === null || sym === void 0 ? void 0 : sym.exc,
                        expiryListIdx: sym === null || sym === void 0 ? void 0 : sym.expLstIdx,
                        stockName: sym === null || sym === void 0 ? void 0 : sym.sname,
                    };
                }),
            };
        }),
        validExpiry: (_c = data === null || data === void 0 ? void 0 : data.validExpiry) === null || _c === void 0 ? void 0 : _c.map(function (list) {
            var _a;
            return {
                displayName: list === null || list === void 0 ? void 0 : list.dpNm,
                exchange: list === null || list === void 0 ? void 0 : list.exc,
                instrument: list === null || list === void 0 ? void 0 : list.ins,
                expiries: (_a = list === null || list === void 0 ? void 0 : list.exp) === null || _a === void 0 ? void 0 : _a.map(function (exp) {
                    return {
                        expiryList: exp === null || exp === void 0 ? void 0 : exp.expLst,
                        idx: exp === null || exp === void 0 ? void 0 : exp.idx,
                    };
                }),
            };
        }),
    };
};
export var getAllExpiryList = function (data, ins, idx) {
    var list = [];
    if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
        data === null || data === void 0 ? void 0 : data.map(function (instrument) {
            if (instrument.instrument === ins) {
                if (instrument.expiries && instrument.expiries.length > 0) {
                    instrument.expiries.map(function (expList) {
                        if ((expList === null || expList === void 0 ? void 0 : expList.idx) === idx) {
                            list = expList === null || expList === void 0 ? void 0 : expList.expiryList;
                        }
                    });
                }
            }
        });
    }
    return list;
};
